
export default function Phase({phaseValue, progressState}) {
  return (
    <div className={phaseValue===progressState ? "progressPhase_chosen" : "progressPhase"}>
        {phaseValue}
    </div>
  )
}
